export const GET_PROFILE_DATA = 'GET_PROFILE_DATA';
export const GET_PROFILE_DATA_SUCCESS = 'GET_PROFILE_DATA_SUCCESS'
export const GET_PROFILE_DATA_FAILURE = 'GET_PROFILE_DATA_FAILURE'
